import { css } from 'styled-components'

type CSSBackgroundImageArgs = {
  urlImage: string
}

export const CSSBackgroundImage = ({
  urlImage
}: CSSBackgroundImageArgs) => css`
  background-image: url(${urlImage});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
`